module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "faces-matched"
    }
  }, [_c('div', {
    staticClass: "input-boxes-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.which_results),
      expression: "which_results"
    }],
    attrs: {
      "type": "radio",
      "id": "radio_all",
      "value": "all"
    },
    domProps: {
      "checked": _vm._q(_vm.which_results, "all")
    },
    on: {
      "change": [function($event) {
        _vm.which_results = "all"
      }, _vm.updateResults]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio_all"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.which_results),
      expression: "which_results"
    }],
    attrs: {
      "type": "radio",
      "id": "radio_matched",
      "value": "matched"
    },
    domProps: {
      "checked": _vm._q(_vm.which_results, "matched")
    },
    on: {
      "change": [function($event) {
        _vm.which_results = "matched"
      }, _vm.updateResults]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio_all"
    }
  }, [_vm._v("Matched")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.which_results),
      expression: "which_results"
    }],
    attrs: {
      "type": "radio",
      "id": "radio_notmatched",
      "value": "notmatched"
    },
    domProps: {
      "checked": _vm._q(_vm.which_results, "notmatched")
    },
    on: {
      "change": [function($event) {
        _vm.which_results = "notmatched"
      }, _vm.updateResults]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio_all"
    }
  }, [_vm._v("Not Matched")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('virtual-list', {
    attrs: {
      "size": 200,
      "remain": 10
    }
  }, _vm._l((_vm.face_matches), function(match, row_number) {
    return _c('div', {
      key: match.runtime_face_uuid,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "rownum"
    }, [_vm._v("\n        #" + _vm._s(row_number) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "text-data"
    }, [_c('div', {
      staticClass: "camera-description"
    }, [_vm._v("\n          " + _vm._s(match.camera_description) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "captured-at"
    }, [_vm._v("\n          " + _vm._s(_vm.getTimeString(match.captured_at)) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "image-area"
    }, [_c('img', {
      attrs: {
        "src": 'https://yakov.owal.io/api/v6/faces/images/' + match.runtime_face_uuid + '?shape=1&clahe=1',
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "results-area"
    }, [_c('img', {
      attrs: {
        "src": _vm.imageUriForFrontendFaceUUID(match.frontend_face_uuid)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name-area"
    }, [_c('div', {
      style: ({
        background: _vm.colorForMatchConfidence(match.match_confidence)
      }),
      attrs: {
        "id": "circle"
      }
    }), _vm._v(" " + _vm._s(_vm.confidenceformat(match.match_confidence)) + " \n          "), _c('router-link', {
      staticClass: "potential-match-name",
      attrs: {
        "to": '/faces/' + _vm.personNameForUUID(match.frontend_face_uuid)
      }
    }, [_vm._v(_vm._s(_vm.personNameForUUID(match.frontend_face_uuid)))])], 1)]), _vm._v(" "), (typeof _vm.not_match_filter[match.runtime_face_uuid] === 'undefined') ? _c('div', {
      staticClass: "row-button-area"
    }, [(match.match_confidence) ? _c('div', [_c('input', {
      attrs: {
        "type": "button",
        "value": "Wrong match?"
      },
      on: {
        "click": function($event) {
          _vm.startFindingMatchForRuntimeFaceUUID(match.runtime_face_uuid)
        }
      }
    })]) : _c('div', [_c('input', {
      attrs: {
        "type": "button",
        "value": "Enter match"
      },
      on: {
        "click": function($event) {
          _vm.startFindingMatchForRuntimeFaceUUID(match.runtime_face_uuid)
        }
      }
    })]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/matchingtags/' + match.runtime_face_uuid
      }
    }, [_vm._v("Why?")])], 1) : _vm._e()])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4109221e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FacesMatched.vue
// module id = 302
// module chunks = 1